module.exports = __webpack_public_path__ + "assets/img/Ober_006.c1915da7.jpg";